var ltr6_module_navigation = (function (ltr6_module_navigation) {

    var message;
    var header;
    var nav;
    var radarPanel;
    var radarButton;
    var placeholder;
    var headerSticky;
    var overlay;
    var radarPanelClose;
    var radarPanelBorder;
    var mainMenuButton;
    var mainMenu;


    ltr6_module_navigation.init = function(){


      //==========================================================================
      // main menu
      //==========================================================================
      mainMenuButton = $('#ltr6-wrapper .ltr6-navigation .ltr6-nav-menu');

      mainMenu = $('#ltr6-wrapper .ltr6-navigation-menu');
      $('#ltr6-wrapper').on('click', '.ltr6-navigation .ltr6-nav-menu', function(e) {
          e.preventDefault();
          // console.log('asd');
        if(mainMenu.hasClass('is-open')) {
          ltr6_module_navigation.closeMainMenu();
        } else {
          setTimeout(function(){
            ltr6_module_navigation.openMainMenu();
          },0); // ugh.
        }
      });
      // function openMainMenu(){
      //   closeRadarPanel();
      //   mainMenuButton.addClass('active');
      //   mainMenu.addClass('is-open');
      // }
      // function closeMainMenu(){
      //   mainMenuButton.removeClass('active');
      //   mainMenu.removeClass('is-open');
      // }

      $('#ltr6-wrapper').on('click', function(event) {
        if(mainMenu.hasClass('is-open')) ltr6_module_navigation.closeMainMenu();
      });

      // $('#ltr6-wrapper').on('click', '.ltr6-navigation .ltr6-navigation-menu a[href^="#"]', function(e) {
      //     e.preventDefault();
      //     var link = $(this).attr('href');
      //     if(link.length>1) {
      //       e.preventDefault();
      //       e.stopPropagation();
      //       // var anchor = link.replace('#', '');
      //       // console.log('anchor',anchor);
      //       var pos = $(link).offset();
      //       var posTop = pos.top;
      //       // posTop -= 10;
      //       // if($('#navigation-primary').length) posTop -= $('#navigation-primary').height();
      //       // if($('#navigation-secondary').length) posTop -= $('#navigation-secondary').height();
      //       // if($('#ltr6-navigation').length) posTop -= $('#ltr6-navigation').height();
            
      //       // posTop = posTop - (52 + 56 + 54);
      //       $('html,body').animate({scrollTop: posTop}, 1000);
      //     }

      //   ltr6_module_navigation.closeMainMenu();
      // });




      //==========================================================================
      // sticky radar menu
      //==========================================================================
      var messageHeight;
      var headerHeight;
      var lastScrollTop;
      // function sticky_nav_debounced(){
      //   if($('.c-global-newsflash--wrapper').length) {
      //     messageHeight = $('.c-global-newsflash--wrapper').height();
      //   } else {
      //     messageHeight = 0;
      //   }
      //   if($('body .l-view header').length) {
      //     headerHeight = $('body .l-view > header').height();
      //   } else {
      //     headerHeight = 0;
      //   }
      //   // headerHeight = 189;
      //   // for new 2.0
      //   // if($('body .l-view header .c-navigation.self-standing').length) {
      //   //   headerHeight = $('body .l-view > header .c-navigation.self-standing').outerHeight(true);
      //   // } else {
      //   //   headerHeight = 0;
      //   // }
      //   // console.log('messageHeight',messageHeight);
      //   // console.log('headerHeight',headerHeight);
      // }
      // var getHeaderHeight = ltr6_module_utilities.debounce(sticky_nav_debounced, 0);
      // window.addEventListener('scroll', getHeaderHeight);
      // sticky_nav_debounced();


      header = $('header');
      nav = $('#ltr6-wrapper .ltr6-navigation');
      radarPanel = $('#ltr6-wrapper .ltr6-navigation-radar-wrapper');
      radarButton = $('#ltr6-wrapper .ltr6-nav-radar');
      placeholder = $('#ltr6-wrapper .ltr6-navigation-placeholder');
      headerSticky = $('.js--navigation');
      overlay = $('#ltr6-wrapper .ltr6-navigation-overlay');
      radarPanelClose = $('#ltr6-wrapper .ltr6-navigation-radar-close');
      radarPanelBorder = $('#ltr6-wrapper .ltr6-navigation-radar-border');

      function sticky_nav() {
        var screenWidth  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if($('.c-global-newsflash--wrapper:visible').length) {
          messageHeight = $('.c-global-newsflash--wrapper').height();
        } else {
          messageHeight = 0;
        }
        if($('body .l-view header').length) {
          headerHeight = $('body .l-view > header > .xf-content-height').height();
        } else {
          headerHeight = 0;
        }

        //this handles the DHL sticky header on scroll.
        var scrollTop = $(window).scrollTop();
        var direction = 1;
        if(lastScrollTop>scrollTop){
          nav.addClass('self-standing');
          $('#ltr6-wrapper').addClass('self-standing');
          direction = -1;
        } else {
          nav.removeClass('self-standing');
          $('#ltr6-wrapper').removeClass('self-standing');
        }

        // console.log('direction',direction);
        lastScrollTop = scrollTop;
        var t = messageHeight+headerHeight;
        // console.log('t',t);
        if (scrollTop > t){
          if(!nav.hasClass('is-fixed')) {
            placeholder.height(nav.outerHeight(true,true));
            nav.addClass('is-fixed-no-trans');

            if($('html').hasClass('full-width-grid')){
              // for v2
              placeholder.height(messageHeight+headerHeight);
              if(screenWidth<1024) placeholder.height(messageHeight+headerHeight + nav.outerHeight(true,true));
              setTimeout(function(){
                nav.addClass('is-fixed');
                $('#ltr6-wrapper').addClass('is-fixed');
                nav.removeClass('is-fixed-no-trans');
              },0);
            } else {
              if(screenWidth<768) placeholder.height(0);
            }
            nav.addClass('is-fixed');
            $('#ltr6-wrapper').addClass('is-fixed');

            radarPanel.addClass('is-fixed');
          }
        } else {
          if(nav.hasClass('is-fixed')) placeholder.height('0px');
          nav.removeClass('is-fixed');
          $('#ltr6-wrapper').removeClass('is-fixed');
          radarPanel.removeClass('is-fixed');
        }        
      }

      $(window).scroll(function(e){
        sticky_nav();
      });

      //don't do on start for DHL v2 - as they haven't done it either :(
      if(!$('html').hasClass('full-width-grid')){
        sticky_nav();
      }




      //==========================================================================
      // show hide radar menu
      //==========================================================================

      $('#ltr6-wrapper').on('click', '.ltr6-navigation .ltr6-nav-radar', function(event) {
        event.preventDefault();
        if(!overlay.hasClass('active')){
          ltr6_module_navigation.openRadarPanel();
        } else {
          ltr6_module_navigation.closeRadarPanel();
        }
      });

      $('#ltr6-wrapper').on('click', '.ltr6-navigation-overlay', function(event) {
        event.preventDefault();
        ltr6_module_navigation.closeRadarPanel();
      });
      $('#ltr6-wrapper').on('click', '.ltr6-navigation-radar-close', function(event) {
        event.preventDefault();
        ltr6_module_navigation.closeRadarPanel();
      });

      // // animate panel sliding down (height)
      // function openRadarPanel(){
      //   closeMainMenu();

      //   radarButton.addClass('active');
      //   overlay.addClass('active');
      //   radarPanel.addClass('active');
      //   radarPanelClose.addClass('active');
      //   radarPanelBorder.hide();
      //   // animate height
      //   var radarPanelHeight = radarPanel[0].scrollHeight;
      //   var radarPanelHeight = radarPanel.outerHeight(true,true);
      //   var size = panelResize();
      //   if(radarPanelHeight > size) {
      //     // its overflowing
      //     radarPanelHeight = size;
      //   } else {
      //     radarPanel.css('overflow','hidden');
      //   }
      //   radarPanel.scrollTop(0);
      //   // console.log('panelResize',size);
      //   // console.log('radarPanelHeight',radarPanelHeight);
      //   TweenLite.fromTo(radarPanel,0.5,{height:0},{height:radarPanelHeight,ease:Power2.easeOut,onComplete:function(){
      //     radarPanel.css('height','auto');
      //     radarPanel.css('overflow','auto');
      //   }});
      // }

      // function closeRadarPanel(){
      //   radarButton.removeClass('active');
      //   overlay.removeClass('active');
      //   radarPanel.removeClass('active');        
      //   radarPanelClose.removeClass('active');
      //   radarPanelBorder.fadeIn();
      // }



      // DEV TEST
      // open the panel on load for dev
      // openRadarPanel();




      //==========================================================================
      // expand radar panel window to fit rest of screen
      //==========================================================================

      // function panelResize(){
      //   var pos = radarPanel.offset();
      //   var height = radarPanel.outerHeight(true,true);
      //   var scrollTop = $(window).scrollTop();
      //   var availableHeight = $(window).height() - pos.top + scrollTop;
      //   // radarPanel.height(availableHeight);
      //   radarPanel.css('max-height',availableHeight + 'px');
      //   return availableHeight;
      //   // radarPanel.scrollTop(0);
      // }
      $(window).scroll(function(e){
        ltr6_module_navigation.panelResize();
      });
      $(window).resize(function(e){
        ltr6_module_navigation.panelResize();
      });
      ltr6_module_navigation.panelResize();





      //==========================================================================
      // tags open up radar
      //==========================================================================
      $('#ltr6-wrapper').on('click', '.ltr6-overview-tag', function(event) {
        event.preventDefault();

        ltr6_module_navigation.openRadarPanel();

        var filter, group;
        if($(this)[0].hasAttribute('data-radar-filter-sector')) {
          filter = $(this).attr('data-radar-filter-sector');
          group = 'sector';

        }
        if($(this)[0].hasAttribute('data-radar-filter-cluster')) {
          filter = $(this).attr('data-radar-filter-cluster');
          group = 'trend_cluster';
        }
        if($(this)[0].hasAttribute('data-radar-filter-focus-area')) {
          filter = $(this).attr('data-radar-filter-focus-area');
          group = 'focus_area';
        }

        ltr6_module_radar.clear_filters();
        ltr6_module_radar.toggleGroup($('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-filters .ltr6-filter-group[data-filter-group="'+group+'"]'));
        
        setTimeout(function(){
          $('#ltr6-wrapper .ltr6-radar-filters .ltr6-filter-group[data-filter-group="'+group+'"] [data-filter-name="'+filter+'"]').find('input').prop('checked','checked');
          ltr6_module_radar.apply_filters();
        },500);
        // console.log('clicked filter:',filter,group);
      });


    };

    ltr6_module_navigation.panelResize = function(){
      var pos = radarPanel.offset();
      var height = radarPanel.outerHeight(true,true);
      var scrollTop = $(window).scrollTop();
      var availableHeight = $(window).height() - pos.top + scrollTop;
      // if(availableHeight>600) availableHeight = 600;
      radarPanel.css('max-height',availableHeight + 'px');
      return availableHeight;
      // radarPanel.scrollTop(0);
    };

    ltr6_module_navigation.openMainMenu = function(){
        ltr6_module_navigation.closeRadarPanel();
        mainMenuButton.addClass('active');
        mainMenu.addClass('is-open');
    };

    ltr6_module_navigation.closeMainMenu = function(){
        mainMenuButton.removeClass('active');
        mainMenu.removeClass('is-open');
    };

    ltr6_module_navigation.openRadarPanel = function(){
        ltr6_module_navigation.closeMainMenu();

        radarButton.addClass('active');
        overlay.addClass('active');
        radarPanel.addClass('active');
        radarPanelClose.addClass('active');
        radarPanelBorder.hide();
        // animate height
        var radarPanelHeight = radarPanel[0].scrollHeight;
        var radarPanelHeight = radarPanel.outerHeight(true,true);
        var size = ltr6_module_navigation.panelResize();
        if(radarPanelHeight > size) {
          // its overflowing
          radarPanelHeight = size;
        } else {
          radarPanel.css('overflow','hidden');
        }
        radarPanel.scrollTop(0);
        // console.log('panelResize',size);
        // console.log('radarPanelHeight',radarPanelHeight);
        TweenLite.fromTo(radarPanel,0.5,{height:0},{height:radarPanelHeight,ease:Power2.easeOut,onComplete:function(){
          radarPanel.css('height','auto');
          radarPanel.css('overflow','auto');
        }});
    };

    ltr6_module_navigation.closeRadarPanel = function(){
        radarButton.removeClass('active');
        overlay.removeClass('active');
        radarPanel.removeClass('active');        
        radarPanelClose.removeClass('active');
        radarPanelBorder.fadeIn();
    };

    return ltr6_module_navigation;
}(ltr6_module_navigation || {}));